import {css} from '../theme/css'
import {spacing} from '../theme/theme'

export const root = css`
  display: grid;
  grid-template-rows: auto auto;
`

export const summaryRoot = css`
  align-items: center;
  min-block-size: 56px;
  display: grid;
  grid-template-columns: auto 1fr auto;
`

export const summaryRootExpander = css`
  cursor: pointer;
`

export const summaryLead = css`
  align-items: center;
  display: flex;
  inline-size: 56px;
  justify-content: center;
`

export const summaryNavigation = css`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 16px;
`

export const summaryNavigationButton = css`
  align-items: center;
  background-color: unset;
  cursor: inherit;
  border: unset;
  display: flex;
  gap: 4px;
`

export const summaryNavigationButtonExpander = css`
  cursor: pointer;
`

export const summaryTrailIcon = css`
  transform: rotate(90deg);

  // Используется чтобы перекрыть transition иконки
  && {
    transition: transform 200ms ease;
  }
`

export const summaryExpandedTrailIcon = css`
  transform: rotate(-90deg);
`
